import type { RouterContextType } from "@/api/permissions/permissions.api";
import { MODULE_KEYS_MAP } from "@/api/permissions/permissions.types";
import ProposalsPage from "@/components/features/Proposals/ProposalsPage";
import { getRouteIcon } from "@/utils/getRouteIconComponent";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { useBreadcrumb } from "@/hooks/useBreadcrumb";
import { useRequestScope } from "@/hooks/useRequestScope";
import { tableSearchSchema } from "@/hooks/useTableUrlPersistence";
import { createFileRoute, useSearch } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/proposals/")({
  component: Proposals,
  validateSearch: tableSearchSchema.parse,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function Proposals() {
  const searchParams = useSearch({ from: "/_authenticated/proposals/" });
  const requestScope = useRequestScope();

  useBreadcrumb([
    {
      title: "Proposals",
      href: "/proposals",
      icon: getRouteIcon(MODULE_KEYS_MAP.proposals),
    },
  ]);

  return <ProposalsPage key={requestScope} searchParams={searchParams} />;
}
